import { createUserOrgSettingsHooks } from "@/hooks/userOrgSettingsHooks";

export const PROOF_TRIGGERS = ["push", "opened", "manual"] as const;
export type ProofTrigger = (typeof PROOF_TRIGGERS)[number];

export type UserProofSettings = {
  proof_enabled: boolean;
  proof_trigger: ProofTrigger;
};

export type UserProofSettingsUpdate = Partial<UserProofSettings>;

const hooks = createUserOrgSettingsHooks<UserProofSettings>({
  resource: "user-proof-settings",
  errorMessage: "Failed to update Proof settings",
});

export const useUserProofSettings = hooks.useSettings;
export const useUpdateUserProofSettings = hooks.useUpdateSettings;
